// extracted by mini-css-extract-plugin
export var animationContainer = "_h1-0";
export var asteriskIcon = "_h1-8";
export var conversationLeftSection = "_h1-4";
export var conversationListItem = "_h1-3";
export var conversationMiddleSection = "_h1-5";
export var conversationRightSection = "_h1-6";
export var detailsContent = "_h1-1";
export var listContainer = "_h1-7";
export var modalContent = "_h1-2";